import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button, Alert} from "reactstrap";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {Form} from 'react-bootstrap'

function DamageUpdate() {

  const [loading, setLoading] = useState(true)
  const [loadingsubmit, setLoadingsubmit]=useState(true)
  const [error, setError]=useState(false)
  const [message, setMessage]=useState(true)

  const [date, setDate] = useState('')
  const [type_damage, setType_damage] = useState('')
  const [text_damage, setText_damage] = useState('')

  const [sensoroptions, setSensoroptions] = useState([])  
  const [sensor, setSensor] = useState('')

  const navigate = useNavigate()

  const token = useSelector((state) => state.userLogin.userInfo.token);

  const { fieldId } = useParams()

  ////////////
  const { t, i18n } = useTranslation();  

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);
  ////////////

  useEffect(() => {

    const fetchData = async () => {

      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
        
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/detail-damage/${fieldId}`, config);

        setDate(response.data.date)
        setType_damage(response.data.type_damage)
        setText_damage(response.data.text_damage)
        setSensor(response.data.sensor)

      } catch (error) {
          
        console.log(error)

      } finally {
        setLoading(false)
      }
    };

    fetchData(); 
  }, [token]);

  useEffect(() => {

    const fetchData = async () => {

      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
          
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/list/`, config);
        
        setSensoroptions(response.data)

      } catch (error) {

      } finally {
        setLoading(false)
      }
    };

    fetchData(); 
  }, [token]);

  const submit = async(e) => {
    setLoadingsubmit(false)

    if (date==='') {
      setMessage(t('The date is empty'))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true);
      return;
    } 

    if (type_damage==='') {
      setMessage(t('The type of damage is empty'))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true);
      return;
    } 

    if (text_damage==='') {
      setMessage(t('The note of the damage is empty'))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true);
      return;
    } 

    if (sensor==='') {
      setMessage(t('The sensor is empty'))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true);
      return;
    } 

    try {

      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };   

      const payload = {
        "date":date,
        "type_damage":type_damage,
        "text_damage": text_damage,
        "sensor":sensor
      }
            
      await axios.put(`${process.env.REACT_APP_BACKEND_API}/insurance/update-damage/${fieldId}/`, payload, config);

    } catch (error) {
      setMessage(t("Some problems occured, please retry and if the problem persists please send an email to info@automaticfarmsolution.com"))
      setError(true)
      setTimeout(function() {
        setError(false)
      }, 5000);
      setLoadingsubmit(true)
      return;
    } finally {
      setLoadingsubmit(true)
      navigate("/damage/")
    }
  }

  return (
    <div>
      <Header/>
      {loading ? (
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                <Spinner>
                  {t('Loading')}
                </Spinner>
              </Col>
            </Row>
          </Container>
        </>
      ):(
        <>
          <Container className="mt--15" fluid>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                  <Card>
                    <CardHeader>
                      <h3>{t('Update Damage Report')}</h3>
                    </CardHeader>
                    <CardBody>
                      <Form>
                        <Form.Label>{t('Set the date of the damage')}</Form.Label>
                        <Form.Control
                          type="date"
                          placeholder={t('Date')}
                          value={date}
                          onChange={(e) => setDate(e.target.value)}>
                        </Form.Control>
                        <br></br>
                        <Form.Label>{t('Type of Damage')}</Form.Label>
                        <Form.Control
                          as="select"
                          placeholder={t('Type of Damage')}
                          value={type_damage}
                          onChange={(e) => setType_damage(e.target.value)}>
                          <option value={""}>

                          </option>
                          <option value={"hail"}>
                            {t('Hail')}
                          </option>
                          <option value={"flood"}>
                            {t('Flood')}
                          </option>
                          <option value={"wildlife"}>
                            {t('Wildlife')}
                          </option>                            
                        </Form.Control>
                        <br></br>
                        <Form.Label>{t('Note')}</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder={t('Note')}
                          value={text_damage}
                          onChange={(e) => setText_damage(e.target.value)}>                      
                        </Form.Control>
                        <br></br>
                        <Form.Label>{t('Select the sensor')}</Form.Label>
                        <Form.Control 
                          as="select" 
                          onChange={(e) => setSensor(e.target.value)} 
                          value={sensor}>
                            <option value={""}>
                          
                            </option>
                            {sensoroptions.map((farmer, index) => (
                              <option key={index} value={farmer.id}>
                                {farmer.id_sensor}
                              </option>
                            ))}
                        </Form.Control>
                        {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                      </Form>
                    </CardBody>
                    <CardFooter>
                      <Row>
                        {loadingsubmit ? (
                          <>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                              <Button color="success" onClick={submit}>
                                {t('Save Damage Report')} <i className="fa-solid fa-code"></i>
                              </Button>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                              <Button color="success" disabled>
                                <Spinner size="sm">
                                  {t('Saving...')}
                                </Spinner>
                                <span>
                                  {' '}{t('Saving...')}
                                </span>
                              </Button>
                            </Col>
                          </>
                        )}
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                          <Link to="/damage/">
                            <Button color="primary">
                              {t('Go back')} <i className="fas fa-rotate-left"></i>
                            </Button>
                          </Link>
                        </Col>
                      </Row>
                    </CardFooter>
                  </Card>
                </Col>
              </Row>
          </Container>
        </>
      )}
    </div>
  )
}

export default DamageUpdate
